// extracted by mini-css-extract-plugin
export default {"container":"ConfirmRegenQrAdmin_container__ES2pa"};